import React from 'react';
import clsx from 'clsx';
import OutlinedTypography from './OutlinedTypography';
import TwitterIcon from '@material-ui/icons/Twitter';
import makeStyles from '@material-ui/core/styles/makeStyles';
import { TWITTER_BASE } from '../../../core/styles/variables';
import Link from '@material-ui/core/Link';
import { TWITTER_SHARE_URL } from '../../../core/variables';
import { TWITTER_SHARE_CONTENT } from '../constants';

const useStyles = makeStyles((theme) => ({
  root: {
    position: 'fixed',
    zIndex: 100,
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    right: 24,
    bottom: '62%',
    [theme.breakpoints.up('sm')]: {
      right: 50,
      bottom: 80,
    },
  },
  title: {
    fontSize: theme.typography.pxToRem(14),
    [theme.breakpoints.up('sm')]: {
      fontSize: theme.typography.pxToRem(20),
    },
  },
  titleLast: {
    marginBottom: theme.spacing(2),
  },
  icon: {
    marginBottom: theme.spacing(1),
  },
  line: {
    width: 28,
  },
  twitter: {
    color: 'white',
    backgroundColor: TWITTER_BASE,
    padding: 3,
    width: 28,
    height: 28,
  },
}));

const ShareButtons = () => {
  const classes = useStyles();
  return (
    <div className={classes.root}>
      <OutlinedTypography classes={{ root: classes.title }}>
        PAGE
      </OutlinedTypography>
      <OutlinedTypography
        classes={{ root: clsx(classes.title, classes.titleLast) }}
      >
        SHARE
      </OutlinedTypography>
      {/*
        * LINEとFacebookはあまりシェアされないため削除。
        * また表示する可能性もありそうなのでコメントアウトにしておきます
      <Link
        target="_blank"
        rel="noreferrer"
        href={
          LINE_SHARE_URL +
          `?url=${LOCAL_DELIVERY}&text=${encodeURIComponent(
            LINE_SHARE_CONTENT,
          )}`
        }
      >
        <img
          src={LineLogo}
          alt="ラインでシェア"
          className={clsx(classes.line, classes.icon)}
        />
      </Link>
      */}
      <Link
        target="_blank"
        rel="noreferrer"
        href={
          TWITTER_SHARE_URL +
          '?text=' +
          encodeURIComponent(TWITTER_SHARE_CONTENT)
        }
      >
        <TwitterIcon classes={{ root: clsx(classes.icon, classes.twitter) }} />
      </Link>
      {/*
      <FacebookButton url={LOCAL_DELIVERY} />
      */}
    </div>
  );
};

export default ShareButtons;
